import React, { Component } from "react";
import classNames from "classnames";
import DateFnsUtils from "@date-io/date-fns";
import { withStyles } from "@material-ui/core";
import { KeyboardDatePicker as MuiDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { FormField } from "react-form";
import FormHelperText from "@material-ui/core/FormHelperText";

const styles = (theme) => ({
    bootstrapInput: {
        borderRadius: 4,
        border: "1px solid #979797",
        padding: "6px 8px",
        width: "calc(100% - 24px)",
        transition: theme.transitions.create(["border-color", "box-shadow"]),
        "&:focus": {
            borderColor: theme.palette.secondary.light,
            boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
        },
        backgroundColor: "#fff",
        fontSize: "15px",
        fontWeight: 500,
        color: "#262626 !important",
    },
    bootstrapInputError: {
        "& input": {
            border: "1px solid #f44336",
        },
    },
    rootLabelShrink: {
        marginLeft: 0,
        marginTop: -2,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: "100%",
    },
    rootLabelShrinkExpansionPanel: {
        //for help with label to offset header
        marginLeft: 0,
        marginTop: -7,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        width: "100%",
    },
    disabled: {
        backgroundColor: "#EEEEEE",
    },
    button: {
        "& button": {
            border: 0,
        },
        "& button:hover": {
            backgroundColor: "rgba(60, 138, 199, 0.08)",
        },
    },
});

class DatePickerWrapper extends Component {
    // The first commit of Material-UI
    //const [selectedDate, setSelectedDate] = React.useState(new Date());

    state = { lastValidDisplayValue: null };

    handleDateChange = (date) => {
        const { fieldApi, eventHandle } = this.props;
        const { setValue, setTouched, setError } = fieldApi;

        if (date) {
            if (!isNaN(date)) {
                var formatDate =
                    (date.getMonth() + 1 < 10 ? "0" : "") +
                    (date.getMonth() + 1) +
                    "/" +
                    ((date.getDate() < 10 ? "0" : "") + date.getDate()) +
                    "/" +
                    date.getFullYear();

                const year = date.getFullYear();
                const currentYear = new Date().getFullYear();
                if (year < currentYear - 100 || year > currentYear + 100) {
                    // Valid date but year is out of the ±100 year range
                    setValue("Invalid Date");
                    setError("Invalid Year");
                } else {
                    setValue(formatDate);
                    setError(null);
                    this.setState({ lastValidDisplayValue: formatDate });
                    if (eventHandle) eventHandle(date.toLocaleDateString());
                }
            } else {
                setValue("Invalid Date");
                setError("Invalid Date");
            }
        } else if (!date) {
            //occurs when date is deleted from form
            setValue("");
            setError(null);
            this.setState({ lastValidDisplayValue: null });
            if (eventHandle) eventHandle("Required");
        }
    };

    handleBlur = () => {
        const { fieldApi } = this.props;
        const { getValue, setError } = fieldApi;
        const value = getValue();

        if (value && value !== "None" && value !== "" && value !== "Invalid Date") {
            const parsedDate = new Date(value);
            if (isNaN(parsedDate)) {
                setError("Invalid Date");
            } else {
                const year = parsedDate.getFullYear();
                const currentYear = new Date().getFullYear();
                if (year.toString().length < 4 || year < currentYear - 100 || year > currentYear + 100) {
                    setError("Invalid Year");
                } else {
                    setError(null);
                }
            }
        } else if (!value || value === "" || value === "None") {
            setError(null);
        }
        // if value === "Invalid Date", leave the existing error as-is
        fieldApi.setTouched();
    };

    validate = () => {
        const { fieldApi } = this.props;
        const { getValue, setError } = fieldApi;
        const value = getValue();

        // Form submission validation - check for incomplete/invalid dates
        if (value && value !== "None" && value !== "") {
            const parsedDate = new Date(value);
            if (isNaN(parsedDate)) {
                setError("Invalid Date");
                return "Invalid Date";
            } else if (parsedDate.getFullYear().toString().length < 4) {
                setError("Invalid Year");
                return "Invalid Year";
            }
        }
        return null;
    };

    componentDidMount() {
        const { autoPopulateAnotherDate, eventHandle, fieldApi } = this.props;
        if (autoPopulateAnotherDate) eventHandle("find other date");
        const initialValue = fieldApi.getValue();
        if (initialValue && initialValue !== "None" && initialValue !== "" && initialValue !== "Invalid Date") {
            this.setState({ lastValidDisplayValue: initialValue });
        }
    }

    render() {
        const { helperText, fieldApi, classes, disabled, eventHandle, required, expansionPanel, ...rest } = this.props;
        const { getValue, getError, getWarning, getSuccess, setTouched } = fieldApi;
        var rawValue = getValue(),
            error = getError(),
            warning = getWarning(),
            success = getSuccess(),
            hasError = !!error,
            errorText = error || warning || success || helperText;

        let InputProps = {};
        InputProps["disableUnderline"] = true;
        InputProps["classes"] = {
            input: classNames(classes.bootstrapInput, disabled && classes.disabled),
            error: classes.bootstrapInputError,
        };

        var value = rawValue === "Invalid Date" ? this.state.lastValidDisplayValue : rawValue;

        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <MuiDatePicker
                    value={value === "None" || value === null || value === "" ? null : value}
                    // initialFocusedDate={value ? value : null}
                    disabled={disabled}
                    required={rest.required}
                    onChange={this.handleDateChange}
                    onBlur={this.handleBlur}
                    format="MM/dd/yyyy"
                    autoOk
                    InputProps={InputProps}
                    InputLabelProps={{
                        shrink: true,
                        classes: {
                            shrink: !expansionPanel ? classes.rootLabelShrink : classes.rootLabelShrinkExpansionPanel,
                        },
                    }}
                    emptyLabel=""
                    okLabel={null}
                    cancelLabel={null}
                    error={hasError}
                    helperText={errorText}
                    DialogProps={{ className: classes.button }}
                    {...rest}
                />
                {required && !hasError && <FormHelperText style={{ marginTop: -1 }}>Required</FormHelperText>}
            </MuiPickersUtilsProvider>
        );
    }
}
DatePickerWrapper.displayName = "DatePickerWrapper";
const DatePickerr = FormField(DatePickerWrapper);

export default withStyles(styles)(DatePickerr);
